module.exports = __webpack_public_path__ + "static/img/040_6.1d7941a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/040_6.jpg
// module id = p2KA
// module chunks = 1